<script>
  import { _ } from 'svelte-i18n';

  function handle_Print(ev) {
    window.print()
  }
</script>

<div>

  <button class="btn btn-wide btn-primary block mx-auto mb-8 print:hidden" on:click="{handle_Print}">
    {$_('results.print')}
  </button>

</div>